export default __webpack_public_path__ + "static/media/2.0561c731.gif";